import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTransferService {
  user_details: any;
  pincode: any;
  user_profile_id: any;
  aadhar_number: any;
  month_and_year: any;
  aadhar_image: any;

  constructor() { }

  userDetailsInPasswordReset(user_obj) {
    this.user_details = user_obj;
  }

  selectedPincode(pincode_obj) {
    this.pincode = pincode_obj;
  }

  userProfileId(id_obj) {
    this.user_profile_id = id_obj;
  }

  userAadharNumber(aadhar_number) {
    this.aadhar_number = aadhar_number;
  }

  userAadharImage(aadhar_image) {
    this.aadhar_image = aadhar_image;
  }

  selectedMonthForIcustomer(month_obj) {
    this.month_and_year = month_obj;
  }
}
